jQuery(document).ready(function(e) {
	jQuery('div.expander').expander({
		slicePoint: 350  // default is 100
	});
	
	/* homepage slider */
	
	$('.slider_container').flexslider({
    	animation: "slide",
		animationLoop: false,
		controlNav: false
  	});

	/* product slider */

	$('#carousel').flexslider({
	    animation: "slide",
	    controlNav: false,
		directionNav: true,
	    animationLoop: false,
	    slideshow: false,
	    itemWidth: 100,
	    itemMargin: 10,
	    asNavFor: '#slider'
 	});

	$('#slider').flexslider({
	    animation: "slide",
	    controlNav: false,
		directionNav: false,
	    animationLoop: false,
	    slideshow: false,
	    sync: "#carousel", 
		start: function(slider){
	    	// trigger zoom for the active slide only
	    	$('#slider .flex-active-slide a img').elevateZoom({
	        	zoomType : "lens", 
				lensShape : "round", 
				lensSize : 200,
				lenBorder: 3,
				borderColour: "#fff",
				containLensZoom: true
	      	});  
	      	// remove zoom container from DOM - prevents multiple zoom images appearing in the slideshow
	    	$('.zoomContainer').remove();
	           
	       },  
	    
	    after: function(slider){
	    	// trigger zoom for the active slide only
	    	$('#slider .flex-active-slide a img').elevateZoom({
	    	   	zoomType : "lens", 
				lensShape : "round", 
				lensSize : 200,
				lenBorder: 3,
				borderColour: "#fff",
				containLensZoom: true
	      	});  
	      	// remove zoom container from DOM - prevents multiple zoom images appearing in the slideshow
	    	$('.zoomContainer').remove();
	           
	       }

 	});

	$( "a.zoom" ).click(function() {
		return false;
	});

});
jQuery(function(){
		jQuery(".toggle_button").click(function(){
			jQuery(".top_row.mobile .mobile_menu").slideToggle();
			return false;
		});
		jQuery(".mobile_menu>div>ul>li>a").click(function(){
			
			jQuery(this).next().slideToggle();
		});
});

jQuery(function(){
	jQuery('.product_detail .accordion_list li>a').click(function() {
		if (!$(this).next().is(':visible')) {
			jQuery('.product_detail .accordion_list li .accordetail').slideUp(500);
			jQuery('.product_detail .accordion_list li').removeClass('active');
			jQuery(this).next().slideDown(500);
			jQuery(this).parent().addClass('active');
		}else{
			jQuery('.product_detail .accordion_list li .accordetail').slideUp(500);
			jQuery('.product_detail .accordion_list li').removeClass('active');
		}
		return false;
	}); 
	
	
	
	jQuery('.filter_section ul li>a').click(function() {
		//jQuery(this).addClass('active');
		if (!$(this).next().is(':visible')) {
			jQuery('.filter_section ul li .drop_menu').slideUp(500);
			jQuery('.filter_section ul li').removeClass('active');
			jQuery(this).next().slideDown(500);
			jQuery(this).parent().addClass('active');
		}else{
			jQuery('.filter_section ul li .drop_menu').slideUp(500);
			jQuery('.filter_section ul li').removeClass('active');
		}
		/*return false;*/
	}); 
	
	
	jQuery('.filter_section .fil > li').hover(function() {
   jQuery(this).children('a').addClass('active');
   }
   , function() {
     jQuery(this).children('a').removeClass('active');
  })
		
	
	
	jQuery('.show_more a').fancybox();	
	jQuery('a.fbox1').fancybox();
	jQuery('#deliveryAndReturns a').fancybox();
	// Cart
	
	 // update when qty changes
	 $("form.cart input[type='number']").change(function() {$("form.cart").submit(); });

	// Quick Find
	
	$( ".search-products" ).click(function() {
		$('input[type=hidden].search-content').val('product');
	});
	
	$( ".search-articles" ).click(function() {
		$('input[type=hidden].search-content').val('article');
	});
	
  // Collection Filters
  $(document).on("click", ".collection.drop_menu .tag a", function(e) {
    
    e.preventDefault();
    
    $(this).parent().parent().children("li").children("a").removeClass("active-tag");
    $(this).addClass("active-tag");
    
    var parts = [];
    $("a.active-tag").each(function() {
      var href = $(this).attr("href");
      href = href.split("/");
      parts.push(href[href.length-1]);
    });

    window.location = "/collections/" + collectionHandle + "/" + parts.join("+");
    
  });
	
});	